import { SelectedProvider } from "../../pages/Screener";

export type Provider = {
  readonly id: number;
  readonly contact: {
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly fullName: string | null;
  };
  readonly externalOrganization: {
    readonly id: number;
  };
};

export type ProviderOption = {
  value: string;
  label: string;
};

export function toOptions(providers: readonly Provider[]): ProviderOption[] {
  return providers.map(provider => ({
    value: String(provider.id),
    label: providerDisplayName(provider)
  }));
}

export function findSelectedProvider(
  providers: readonly Provider[],
  value: string | undefined
): Provider | undefined {
  return providers.find(provider => String(provider.id) === value);
}

export function selectProvider(provider: Provider): SelectedProvider {
  return {
    externalOrganizationId: provider.externalOrganization.id,
    externalProviderId: provider.id,
    providerName: providerDisplayName(provider)
  };
}

export function providerDisplayName(provider: Provider): string {
  const { firstName, lastName, fullName } = provider.contact;
  return fullName?.trim() || `${firstName ?? ""} ${lastName ?? ""}`.trim();
}
